"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const createIconComponent_1 = require("../createIconComponent");
exports.default = createIconComponent_1.default("Duplicate", React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M1.9,23.3V6.2l10.2,0l3.6,3.2v13.9H1.9z M10.5,6.8v4.3h5.2 M21.9,4.2v13.9h-6.2V9.6l-3.6-3.4H8V1h10.7L21.9,4.2\n\tz M16.7,1.3v4.3h5.2" }));
//# sourceMappingURL=Duplicate.js.map